import {makeAutoObservable} from "mobx";
import {apiServiceV2} from "../../services/apiService";
import {globalStore} from "../../global.store";
import {cerebrumStore} from "../../modules/cerebrum/cerebrum.store";

class CardsStore {
    editableRoomData: any = null;
    popupContentType: string = "";

    constructor() {
        makeAutoObservable(this);
    }

    setEditableRoomData = (data: any) =>{
        this.editableRoomData = data;
    }

    setPopupContentType = (str: string) =>{
        this.popupContentType = str;
    }

    deleteRoom = async () => {
        const response = await apiServiceV2.deleteRoom(this.editableRoomData.id);
        if (!response.error) this.setEditableRoomData(null);
    };

    setRoomStatus = async (type: number) => {
        const response = await apiServiceV2.setRoomStatus(this.editableRoomData.id, type);
        if (!response.error) {
            this.editableRoomData.status = type;
            globalStore.setToasts(true, 'its_success');
        } else {
            globalStore.setToasts(true, 'something_went_wrong');
        }
        this.setEditableRoomData(null);
    };

    renameCard = async (value: string) => {
        const response = await apiServiceV2.setRoomName(this.editableRoomData.id, value);
        if (!response.error) {
            cerebrumStore.setRoomInfo(cerebrumStore.roomInfo.map((room: any) => {
                if(room.id === this.editableRoomData.id) {
                    room.name = value;
                }
                return room;
            }))
            this.setEditableRoomData(null);
            globalStore.setToasts(true, 'its_success');
        } else {
            globalStore.setToasts(true, 'something_went_wrong');
        }
    };
}


export const cardsStore = new CardsStore();